import React from "react";
import PropTypes from "prop-types";

import { Settings } from "@salesforce/design-system-react";
import IconContext from "components/utils/IconContext";
import RewardsModalContent from "./RewardsModalContent";
import WebComponent from "../WebComponent";
import { t } from "lib/I18n";

Settings.setAppElement("#main-wrapper");

export default class RewardsModal extends React.Component {
  static propTypes = {
    rewards: PropTypes.array.isRequired,
    nextChallenge: PropTypes.object.isRequired,
    showRecommendations: PropTypes.bool,
    badgeRatings: PropTypes.object.isRequired,
    moduleApiName: PropTypes.string.isRequired,
    unitType: PropTypes.string.isRequired,
    colorScheme: PropTypes.string.isRequired,
    sharing: PropTypes.object,
    onClose: PropTypes.func,
    fromLearningPath: PropTypes.bool,
    learningPathUri: PropTypes.string,
    isMyTrailhead: PropTypes.bool,
  };

  static defaultProps = {
    sharing: undefined,
    onClose: undefined
  };

  state = {
    isOpen: true,
    hasNewRecommendations: false,
    showNewRecommendations: true
  };

  modal = React.createRef();

  componentDidMount() {
    if (this.modal.current) {
      this.modal.current.addEventListener("requestclose", this.toggleOpen);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showNewRecommendations && !this.state.showNewRecommendations) {
      this.removeRecommendationSlot();
    }
  }

  removeRecommendationSlot = () => {
    const celebrationModal = document.querySelector('th-celebration-modal');
    if (celebrationModal) {
      celebrationModal.removeLastPageSlot();
    }
  };

  toggleOpen = () => {
    const { isOpen } = this.state;
    const { onClose } = this.props;
    this.setState({ isOpen: !isOpen });

    if (isOpen && onClose) {
      onClose();
    }
  };

  challengeType = () => {
    return this.props.rewards[0].challenge_type;
  }

  handleRecommendationsStateChange = (e) => {
    const { state } = e.detail;
    if (state === "error" || state === "empty") {
      this.setState({ showNewRecommendations: false });
    }
    if (state === "loaded" && !this.state.hasNewRecommendations) {
      this.setState({ hasNewRecommendations: true });
    }
  };

  renderNewRecommendations = () => {
    if(this.props.isMyTrailhead) {
      return null;
    }

    if (!this.state.showNewRecommendations || this.props.fromLearningPath) {
      return null;
    }

    if (this.props.nextChallenge.next_challenge || this.props.nextChallenge.next_parent) {
      return null;
    }

    const attrs = {
      uuid: this.props.moduleUid
    };

    const events = {
      statechange: this.handleRecommendationsStateChange
    };

    return (
      <div slot="pageLast" className="th-modal__content--full-screen">
        {this.state.hasNewRecommendations && (
          <>
            <h1 className="th-celebration-modal__heading">
              {t('reward.recommended_content_header')}
            </h1>
            <p>
              {t('reward.recommended_content_desc')}
            </p>
          </>
        )}
        <WebComponent tagName="th-recommendations-updated" attrs={attrs} events={events} />
      </div>
    );
  };

  render() {
    return (
      <IconContext>
        <th-celebration-modal
          ref={this.modal}
          open={this.state.isOpen}
          assistive-text={`${this.challengeType()} Complete: ${this.props.rewards[0].points} Points`}
        >
          <div slot="page1" className="th-modal__content--full-screen">
            <RewardsModalContent {...this.props} modalRef={this.modal} hasNewRecommendations={this.state.hasNewRecommendations} />
          </div>

          {this.renderNewRecommendations()}
        </th-celebration-modal>
      </IconContext>
    );
  }
}
